<div class="main-screen-container">
  <div class="top-row">
    <h3 class="w-100">Profil: {{user?.name + ' ' + user?.surname}}</h3>
  </div>
  
</div>
